module.exports = __webpack_public_path__ + "static/media/icon.bd807912.svg";